import NewsHomeContainer from './NewsHomeContainer';

export default NewsHomeContainer;
